import React, { useEffect, useState } from "react";
import {
  getGroups,
  getSubGroups,
 
  getTrainingMaterials,
  addTrainingMaterial,
  updateTrainingMaterial,
  deleteTrainingMaterial,
} from "../Service/apiService";
 
import toast, { Toaster } from "react-hot-toast";
import { deleteFileFromAzure, uploadFileToAzure } from "../Service/azureUpload";

function TrainingMaterialPage() {
  const [form, setForm] = useState({
    groupID: "",
    subGroupID: "",

    contentType: "",
    materialName: "",
    file: null,
  });

  const [editId, setEditId] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [groups, setGroups] = useState([]);
  const [subGroups, setSubGroups] = useState([]);
 const [loading, setLoading] = useState(false);
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 5; // you can customize
const filteredMaterials = materials.filter((m) =>
  m.materialName.toLowerCase().includes(searchTerm.toLowerCase())
);

const totalPages = Math.ceil(filteredMaterials.length / itemsPerPage);
const startIdx = (currentPage - 1) * itemsPerPage;
const paginatedMaterials = filteredMaterials.slice(startIdx, startIdx + itemsPerPage);


  const loadAll = async () => {
    try {
      const [groupList, materialList] = await Promise.all([
        getGroups(),
      
        getTrainingMaterials(),
      ]);
      setGroups(groupList);
      
      setMaterials(materialList);
    } catch (err) {
      //toast.error("Failed to load initial data");
      console.error(err);
    }
  };

  const loadSubGroups = async (groupID) => {
    if (!groupID) return;
    try {
      const subs = await getSubGroups(groupID);
      
      setSubGroups(subs);
    } catch (err) {
      //toast.error("Failed to load subgroups");
    }
  };

  useEffect(() => {
    loadAll();
  }, []);

  useEffect(() => {
    if (form.groupID) loadSubGroups(form.groupID);
  }, [form.groupID]);

 const handleSubmit = async (e) => {
  e.preventDefault();

  // Validate required fields
  if (!form.groupID) {
    toast.error("Group is required");
    return;
  }

  if (!form.subGroupID) {
    toast.error("Sub Group is required");
    return;
  }
if (!form.contentType) {
  toast.error("Content Type is required");
  return;
}

  if (!form.materialName || form.materialName.trim() === "") {
    toast.error("Material name is required");
    return;
  }

  if (!editId && !form.file) {
    toast.error("File is required for new training material");
    return;
  }

  setLoading(true);  // start loading
  try {
    let fileUrl = "";
    if (form.file) {
      fileUrl = await uploadFileToAzure(form.file);
    }

    const payload = {
      trainingMaterialID: editId,
      groupID: Number(form.groupID),
      subGroupID: Number(form.subGroupID),
      materialName: form.materialName.trim(),
      fileName: form.file?.name || "",
      fileType: form.file?.type || "",
      fileSize: form.file?.size || 0,
      fileUrl,
       contentType: form.contentType,
    };

    if (editId) {
      await updateTrainingMaterial(payload);
      toast.success("Training material updated");
      setLoading(false); // stop loading
    } else {
      await addTrainingMaterial(payload);
      toast.success("Training material added");
      setLoading(false); // stop loading
    }

    setForm({
      groupID: "",
      subGroupID: "",
      materialName: "",
      file: null,
       contentType: "",
    });
    setEditId(null);
    loadAll();
  } catch (err) {
    console.error("Submission error:", err);
    toast.error("Failed to save training material");
  }
};


  const handleEdit = (material) => {
    setForm({
      groupID: String(material.groupID),
      subGroupID: String(material.subGroupID),
      materialName: material.materialName,
      file: null,
    });
    setEditId(material.trainingMaterialID);
    loadSubGroups(material.groupID);
  };

   

  const handleDelete = async (id) => {
  const material = materials.find(m => m.trainingMaterialID === id);
  if (!material) return;

  if (window.confirm("Delete this training material and its file?")) {
    try {
      if (material.fileUrl) {
        await deleteFileFromAzure(material.fileUrl);
      }
      await deleteTrainingMaterial(id);
      toast.success("Deleted successfully");
      loadAll();
    } catch (err) {
      console.error("Delete failed:", err);
      toast.error("Failed to delete");
    }
  }
};


  return (
    <div className="max-w-3xl mx-auto p-6">
      <Toaster position="top-right" />
      <h2 className="text-2xl font-bold mb-4">Training Materials</h2>

      <form onSubmit={handleSubmit} className="space-y-4 mb-8">
        
        <select
          value={form.groupID}
          onChange={(e) => setForm({ ...form, groupID: e.target.value })}
           
          className="w-full p-2 border rounded"
        >
          <option value="">Select Group</option>
          {groups.map((g) => (
            <option key={g.groupID} value={g.groupID}>
              {g.groupName}
            </option>
          ))}
        </select>

      <select
  value={form.subGroupID}
  onChange={(e) => setForm({ ...form, subGroupID: e.target.value })}
  className="w-full p-2 border rounded"
>
  <option value="">Select Level/Permission</option>
  {subGroups
    .filter((s) => String(s.parentGroupID) === String(form.groupID))
    .map((s) => (
      <option key={s.subGroupID} value={s.subGroupID}>
        {s.subGroupName}
      </option>
    ))}
</select>

<select
  value={form.contentType}
  onChange={(e) => setForm({ ...form, contentType: e.target.value })}
  className="w-full p-2 border rounded"
  required
>
  <option value="">Select Content Type</option>
  <option value="Document">Document</option>
  <option value="Training Video">Training Video</option>
</select>

       

        <input
          type="text"
          placeholder="Material Name"
          value={form.materialName}
          onChange={(e) => setForm({ ...form, materialName: e.target.value })}
           
          className="w-full p-2 border rounded"
        />

        <input
          type="file"
          onChange={(e) => setForm({ ...form, file: e.target.files[0] })}
          className="w-full p-2 border rounded"
        />

        <div className="flex gap-4">
         <button
  type="submit"
  disabled={loading}
  className={`px-4 py-2 rounded text-white ${
    loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
  }`}
>
  {loading ? (editId ? "Updating..." : "Adding...") : editId ? "Update" : "Add"} Material
</button>

          {editId && (
            <button
              type="button"
              onClick={() => {
                setEditId(null);
                setForm({
                  groupID: "",
                  subGroupID: "",
              
                  materialName: "",
                  file: null,
                });
              }}
              className="bg-gray-400 text-white px-4 py-2 rounded"
            >
              Cancel
            </button>
          )}
        </div>
      </form>

   <ul className="space-y-4">
    <input
  type="text"
  placeholder="Search by name..."
  value={searchTerm}
  onChange={(e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // reset to first page on search
  }}
  className="w-full mb-4 p-2 border rounded"
/>

  {paginatedMaterials.map((m) => {
    // Find group and subgroup names by their IDs
    const group = groups.find((g) => g.groupID === m.groupID);
    if(m.subGroupID >0)
      loadSubGroups(m.subGroupID)
    const subGroup = subGroups.find((s) => s.subGroupID === m.subGroupID);

    return (
      <li
        key={m.trainingMaterialID}
        className="border p-4 rounded shadow flex justify-between items-center"
      >
        <div>
            
          <p className="font-semibold">{m.materialName}</p>
          <p className="text-sm text-gray-600">
            Content Type: <span className="font-medium">{m.contentType || "N/A"}</span>
          </p>

          <p className="text-sm text-gray-600">
            Group: <span className="font-medium">{group?.groupName || "Unknown"}</span> | Level/Permission: <span className="font-medium">{subGroup?.subGroupName || "Unknown"}</span>
          </p>
          
          <a
            href={m.fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 text-sm"
          >
            View File
          </a>
        </div>
        <div className="space-x-2">
          <button hidden
            onClick={() => handleEdit(m)}
            className="bg-yellow-500 text-white px-3 py-1 rounded"
          >
            Edit
          </button>
          <button
            onClick={() => handleDelete(m.trainingMaterialID)}
            className="bg-red-600 text-white px-3 py-1 rounded"
          >
            Delete
          </button>
        </div>
      </li>
      
    );
  })}
  <div className="flex justify-center mt-4 space-x-2">
  {Array.from({ length: totalPages }, (_, i) => (
    <button
      key={i}
      onClick={() => setCurrentPage(i + 1)}
      className={`px-3 py-1 rounded ${
        currentPage === i + 1
          ? "bg-blue-600 text-white"
          : "bg-gray-200 text-black"
      }`}
    >
      {i + 1}
    </button>
  ))}
</div>

</ul>

    </div>
  );
}

export default TrainingMaterialPage;
